import React, { useEffect, useState, useMemo, useRef } from 'react';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import { AgGridReact } from 'ag-grid-react';
import { useAdminCommonStore } from 'src/hooks/admin/adminCommon';
import NoResultContent from 'src/pages/HomePageContent/NoResultContent';
import { __remove, __set } from 'src/store/axios_indicator';
import Helper from 'src/helper/Helper';
import { useObjCommonFilterStore } from "../../../hooks/objCommonFilter";
import System from 'src/helper/system';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';

export function AdminComplianceList() {
    const [__check] = useAxiosIndicatorCheck();
    const [{ }, { fetch_compliance_Management_list }] = useAdminCommonStore();
    const [{ filter_list }] = useObjCommonFilterStore();
    const [rowData, setRowData] = useState([]);
    const gridRef = useRef();
    const [agGridFiltered, setAgGridFiltered] = useState(0);
    const [complianceManagementList, setComplianceManagementList] = useState([]);
    const [{ system_alert_list}, { system_alert_indicator  }, { }] = useDOMAttachToSystemStore();
    const loadSurveyLink = (params) => (
        <div
            className='text-blue cursor-pointer'  onClick={() => openSurveyForm(params.data?.surveyResponse)}
        >
            View Response
        </div>
    );
    const [columnDefs] = useState([
        {
            field: 'wcsOrderNumber',
            minWidth: 150,
            headerName: 'WCS ORDER NUMBER',
            headerTooltip: 'WCS ORDER NUMBER',
            sortable: true,
            comparator: Helper.textSortingAgGrid,
            unSortIcon: true
        },
        {
            field: 'formCompletionDate',
            headerName: 'FORM COMPLETION DATE',
            headerTooltip: 'FORM COMPLETION DATE',
            sortable: true,
            unSortIcon: true,
            comparator: Helper.dateSortingAgGrid
        },
        {
            field: 'organizationName',
            headerName: 'ORGANIZATION NAME',
            headerTooltip: 'ORGANIZATION NAME',
            sortable: true,
            unSortIcon: true,
            comparator: Helper.textSortingAgGrid
        },
        {
            field: 'billToCountry',
            headerName: 'BILL TO COUNTRY',
            headerTooltip: 'BILL TO COUNTRY',
            sortable: true,
            unSortIcon: true,
            comparator: Helper.textSortingAgGrid,
        },
        {
            field: 'shipToCountry',
            headerName: 'SHIP TO COUNTRY',
            headerTooltip: 'SHIP TO COUNTRY',
            sortable: true,
            unSortIcon: true,
            comparator: Helper.textSortingAgGrid
        },
        {
            field: 'surveyResponse',
            headerName: 'SURVEY RESPONSE',
            headerTooltip: 'SURVEY RESPONSE',
            sortable:false,
            unSortIcon: true,
            cellRenderer: loadSurveyLink,
        },
    ]);

    const defaultColDef = useMemo(() => ({
        flex: 1,
        sortable: true,
        filter: true,
        enableRowGroup: true,
        enableValue: true,
        resizable: true
    }), []);

    useEffect(() => {
        const fetchAPICall = async () => {
            __set('ADMIN_COMPLIANCE_MANAGEMENT_API_CALL');
            const formData = new FormData();
            formData.append([filter_list?.searchText?.key], filter_list?.searchText?.searchKeyword);
            const response = await fetch_compliance_Management_list(formData);
            if (response?.ErrorCode === '403') {
                system_alert_indicator({
                    name: "accessDenied",
                    message: response?.Message,
                    type: "danger",
                    isDisplayIcon: true,
                    isDisplay: false
                });
            }
            if(response?.length===0){
                system_alert_indicator({
                    name: 'complianceManager',
                    message: "Your search yielded no results.",
                    type: "danger",
                    isDisplayIcon: true,
                    isDisplay: false,
                })
            }
            setComplianceManagementList(response);
            __remove('ADMIN_COMPLIANCE_MANAGEMENT_API_CALL');
        };
        if (Object.entries(filter_list).length > 0) {
            fetchAPICall()
        }else{
            setComplianceManagementList([]);
        }
    }, [filter_list]);
    useEffect(() => {
        if (Array.isArray(complianceManagementList)) {
            const _itemList = complianceManagementList.map((_item) => ({
                wcsOrderNumber: _item.wcsOrderNumber,
                formCompletionDate: _item.formCompletionDate ? Helper.getDatepickerFormatAdminConsole(_item.formCompletionDate) : "",
                organizationName: _item.organizationName,
                billToCountry: _item.billToCountry,
                shipToCountry: _item.shipToCountry,
                surveyResponse: _item.surveyResponse,
            }));

            setRowData((prevRowData) => {
                if (JSON.stringify(prevRowData) !== JSON.stringify(_itemList)) {
                    return _itemList;
                }
                return prevRowData;
            });
        }
    }, [complianceManagementList]);


    const openSurveyForm=(data)=>{
        data=data.slice().sort((a, b) => a.forM_QUESTION_ID - b.forM_QUESTION_ID)
        System.popup("SurveyResponsePopUp", { data})
    }
    const gridUpdateCallback = (event) => {
        setAgGridFiltered(event.api.getDisplayedRowCount());
    }

    const onSelectionChanged = () => {
        setSelectedUserCount(gridRef?.current?.api?.getSelectedRows().length);
    }

    const isRowSelectable = useMemo(() => {
        return (params) => {
            return params.data && (params.data.Source !== 'SAP' && params.data.Active !== 'Inactive' && System.validateDomain(params.data.Email) === false);
        };
    }, []);
    const onGridReady = (params) => {
        setAgGridFiltered(params.api.getDisplayedRowCount());
        params.api.addEventListener('filterChanged', gridUpdateCallback)
        params.api.addEventListener('filterModified', gridUpdateCallback)
    };
    return (
        <>
       {rowData.length > 0 && <div className='w-100 d-flex align-items-center justify-content-between status-bar p-2'>
                <div className="d-flex justify-content-start">
                    Filtered Line Count: <b>{agGridFiltered}</b>
                </div>
            </div>}
            <div className='bg-black p-3'>
                <div className='d-flex align-items-center justify-content-between'>
                    <div className='d-flex align-items-center'>
                        
                    </div>
                </div>
            </div>

            {__check(['ADMIN_COMPLIANCE_MANAGEMENT_API_CALL', 'COMMON_API_CALL']).render}
            {!__check(['ADMIN_COMPLIANCE_MANAGEMENT_API_CALL', 'COMMON_API_CALL']).status &&
                <>
                    {rowData.length > 0 ?
                        <div className="ag-theme-alpine ag-grd-hg mb-5">
                            <AgGridReact
                                ref={gridRef}
                                rowData={rowData}
                                columnDefs={columnDefs}
                                defaultColDef={defaultColDef}
                                rowSelection={'multiple'}
                                suppressRowClickSelection={true}
                                autoGroupColumnDef={{
                                    headerName: 'Group',
                                    minWidth: 220,
                                }}
                               
                                onGridReady={onGridReady}
                                onSelectionChanged={onSelectionChanged}
                                isRowSelectable={isRowSelectable}
                               
                            >
                            </AgGridReact>
                        </div> :
                        <>
                            {system_alert_list?.complianceManager?.message ?
                                <div className='container mt-5'>
                                    <NoResultContent message={system_alert_list?.complianceManager?.message} isDisplay={false} />
                                </div>
                                : <div className='d-block pt-5 pb-5 mt-5 mb-5 minh150'> </div>
                            }
                        </>
                    }
                </>
            }
        </>
    );
}
